import { render, staticRenderFns } from "./PostCovenants.vue?vue&type=template&id=f82a664c&scoped=true&"
import script from "./PostCovenants.vue?vue&type=script&lang=js&"
export * from "./PostCovenants.vue?vue&type=script&lang=js&"
import style0 from "./PostCovenants.vue?vue&type=style&index=0&id=f82a664c&prod&lang=scss&scoped=true&"
import style1 from "./PostCovenants.vue?vue&type=style&index=1&id=f82a664c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82a664c",
  null
  
)

export default component.exports